export default "__VITE_ASSET__B1y2h$k3__"